// extracted by mini-css-extract-plugin
export var actionButton = "_ik-0";
export var actionMenuContainer = "_ik-i";
export var bubble = "_ik-2";
export var bubbleActionMenu = "_ik-j";
export var bubbleContext = "_ik-6";
export var bubbleItems = "_ik-7";
export var customer = "_ik-3";
export var divider = "_ik-8";
export var fileList = "_ik-9";
export var hiddenComment = "_ik-o";
export var infoAbove = "_ik-a";
export var internal = "_ik-4";
export var lightActionButton = "_ik-1";
export var link = "_ik-b";
export var merchant = "_ik-5";
export var message = "_ik-c";
export var profilePicture = "_ik-e";
export var quillToolbarContainer = "_ik-f";
export var senderDate = "_ik-g";
export var senderDateCustomer = "_ik-h";
export var senderName = "_ik-d";
export var time = "_ik-k";
export var uploadedImage = "_ik-l";
export var username = "_ik-m";
export var xsmall = "_ik-n";